import React from 'react';
import { ShieldCheck } from 'lucide-react';

const TermsModal = ({ isOpen, onAccept }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4">
      <div className="bg-white dark:bg-[#18181B] border border-zinc-200 dark:border-zinc-800 rounded-xl shadow-2xl max-w-lg w-full overflow-hidden flex flex-col">
        
        <div className="p-6 flex-1">
          <div className="flex items-center gap-3 mb-5">
            <div className="h-10 w-10 rounded-full bg-emerald-100 dark:bg-emerald-900/30 flex items-center justify-center shrink-0">
              <ShieldCheck className="h-5 w-5 text-emerald-600 dark:text-emerald-400" />
            </div>
            <h2 className="font-display font-bold text-xl text-zinc-900 dark:text-zinc-50">
              AmiGuru Terms of Service
            </h2>
          </div>

          <p className="text-zinc-600 dark:text-zinc-300 text-sm mb-4 leading-relaxed">
            <strong>Welcome to AmiGuru!</strong> Before we start generating patterns, let's establish some basic ground rules regarding copyright and creative respect.
          </p>

          <ul className="space-y-3 mb-6 text-sm text-zinc-600 dark:text-zinc-300">
            <li className="flex gap-2">
              <span className="text-emerald-500">•</span>
              <span><strong>Upload Responsibly:</strong> By using this tool, you confirm that you own the rights to the reference images you upload, or you have explicit permission to use them.</span>
            </li>
            <li className="flex gap-2">
              <span className="text-emerald-500">•</span>
              <span><strong>Respect Other Artists:</strong> AmiGuru is designed to help you draft patterns from your own sketches, physical prototypes, or public domain concepts. Please do not use this app to reverse-engineer other designers' original works or to replicate copyrighted characters.</span>
            </li>
            <li className="flex gap-2">
              <span className="text-emerald-500">•</span>
              <span><strong>Your Liability:</strong> AmiGuru is a generative drafting utility. You are solely legally responsible for the patterns, physical objects, and derivative works you create and distribute using this platform.</span>
            </li>
          </ul>

          <div className="bg-zinc-100 dark:bg-zinc-800/50 p-3 rounded-lg border border-zinc-200 dark:border-zinc-700/50">
             <p className="text-sm font-medium text-zinc-800 dark:text-zinc-200 text-center">
               By clicking "I Agree," you promise to respect fellow creators and use this tool ethically!
             </p>
          </div>
        </div>

        <div className="border-t border-zinc-200 dark:border-zinc-800 bg-zinc-50 dark:bg-[#09090B] p-4 flex justify-end gap-3">
          <button
            onClick={() => window.location.href = 'https://google.com'}
            className="px-4 py-2 text-sm font-medium text-zinc-600 dark:text-zinc-400 hover:text-zinc-900 dark:hover:text-zinc-100 transition-colors"
          >
            Decline
          </button>
          <button
            onClick={onAccept}
            className="px-5 py-2 text-sm font-medium bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg shadow-sm transition-colors"
          >
            I Agree, Let's Craft!
          </button>
        </div>

      </div>
    </div>
  );
};

export default TermsModal;